import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, selectColumn } from "./ColumnHelpers";

export function column_Depth(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return selectColumn(context, "importDepth", "depth", {
		isNumber: true,
		options: context.depths,
		updateSubRows: context.dealBasedSubRowUpdate,
	});
}
